module.exports = __webpack_public_path__ + "media/images/icons/spots-f605f3f5d25c3d5ede44f8b7f5b88d6b.svg";